import './no-auth.less';
import noAuthComponent from './no-auth.component';
import noAuthRoutes from './no-auth.routes';
import servicesModule from './services/services.module';
import buyModule from './buy/buy.module';
import offersModule from './offers/offers.module';
import componentsModule from './components/components.module';


export default angular
  .module('fizyweb.paycell.noauth', [
    servicesModule,
    componentsModule,
    buyModule,
    offersModule
  ])
  .component('fizyPaycellNoAuth', noAuthComponent)
  .config(noAuthRoutes).name;


// WEBPACK FOOTER //
// src/app/no-auth/no-auth.module.ts